import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';

@Injectable()
export class AppUrl {
  static get USER_URL(): string {
    return environment.appUrl + 'user/';
  }

  static get STUDENT_URL(): string {
    return environment.appUrl + 'student/';
  }

  static get LOGIN(): string {
    return AppUrl.STUDENT_URL + 'login';
  }

  static get SELF(): string {
    return AppUrl.STUDENT_URL + 'self';
  }

  static ADMIT_CARD(): string {
    return AppUrl.STUDENT_URL + 'admit-card';
  }

  static ASSIGNED_SUBJECT(): string {
    return AppUrl.STUDENT_URL + 'assigned-subject';
  }

  static UPCOMING_EXAM(): string {
    return AppUrl.STUDENT_URL + 'upcoming-subject';
  }

  static LIVE_EXAM(): string {
    return AppUrl.STUDENT_URL + 'ongoing-subject';
  }

  static COMPLETED_EXAM(): string {
    return AppUrl.STUDENT_URL + 'monitored-subject';
  }

  static CURRENT_TIME(): string {
    return AppUrl.USER_URL + 'current-time';
  }

  static UPLOAD_ANSWER(): string {
    return AppUrl.STUDENT_URL + 'subjective-upload';
  }

  static ATTEND_EXAM(): string {
    return AppUrl.STUDENT_URL + 'attend-exam';
  }

  static SYNC_QUESTIONS(): string {
    return AppUrl.STUDENT_URL + 'sync-exam';
  }

  static INVIGILATOR_NOTIFICATION(): string {
    return AppUrl.STUDENT_URL + 'invigilator-notification';
  }

  static SUBMIT_EXAM(): string {
    return AppUrl.STUDENT_URL + 'submit-exam';
  }

  static INVIGILATOR_NOTIFICATIONS(): string {
    return AppUrl.USER_URL + 'invigilator-notification-list';
  }

  static RESULT(): string {
    return AppUrl.STUDENT_URL + 'exam-results';
  }

  static MARK_READ(): string {
    return AppUrl.STUDENT_URL + 'read-notification';
  }

  static GENERAL_NOTIFICATION_LIST(): string {
    return AppUrl.STUDENT_URL + 'general-notification-list';
  }

  static SUPPORT_TICKET(id?: any): string {
    if (id)  return AppUrl.STUDENT_URL + 'support-ticket/'+id;
    else return AppUrl.STUDENT_URL + 'support-ticket';
  }

  static QUESTION_TYPE(): string {
    return AppUrl.USER_URL + 'paper-type';
  }

  static ADD_QUESTIONS(uniqueId: string): string {
    return AppUrl.USER_URL + 'schedule-subject/'+uniqueId;
  }


  static UPDATE_PASSWORD(): string {
    return AppUrl.USER_URL + 'update-password';
  }

  static UPDATE_SELF(): string {
    return AppUrl.USER_URL + 'update-self';
  }

  static LOGOUT(): string {
    return AppUrl.USER_URL + 'logout';
  }

  static UPDATE_PROFILE_IMAGE(): string {
    return AppUrl.USER_URL + 'update-profile-image';
  }

  static FILE_UPLOAD(): string {
    return AppUrl.USER_URL + 'file-upload';
  }

  static MULTIPLE_FILE_UPLOAD(): string {
    return AppUrl.USER_URL + 'file-multiple-upload';
  }

  static COUNTRY(): string {
    return AppUrl.USER_URL + 'countries';
  }

  static USERS(): string {
    return AppUrl.USER_URL + 'user';
  }

  static SESSION_LIST(): string {
    return AppUrl.USER_URL + 'session-list';
  }

  static STATES(uniqueId?: any): string {
    if (uniqueId) return AppUrl.USER_URL + 'states/' + uniqueId;
    else return AppUrl.USER_URL + 'states';
  }

  static SESSION(uniqueId?: any): string {
    if (uniqueId) return AppUrl.USER_URL + 'session/' + uniqueId;
    else return AppUrl.USER_URL + 'session';
  }

  static DEFAULT_SESSION(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.USER_URL + 'session-default/' + uniqueId;
    } else {
      return AppUrl.USER_URL + 'session-default';
    }
  }

  static STUDENT_PHOTO(): string {
    return AppUrl.USER_URL + 'student-profile-upload';
  }

  static STUDENT_PHOTO_ID_UPDATE(uniqueId: any): string {
    return AppUrl.USER_URL + 'student-profile-update/'+uniqueId;
  }

  static STUDENT_STATUS(uniqueId: any): string {
    return AppUrl.USER_URL + 'student-status/' + uniqueId;
  }

  static SESSION_COUNT(): string {
    return AppUrl.USER_URL + 'session-count';
  }

  static SESSION_STATUS(uniqueId: any, status: any): string {
    if (status == 'default_session')
      return AppUrl.USER_URL + 'default-session';
    else if (status == 're-registration-session')
      return AppUrl.USER_URL + 're-registration-session/' + uniqueId;
    else if (status == 're-registration-entry-session')
      return AppUrl.USER_URL + 're-registration-entry-session/' + uniqueId;
    else if (status == 'admission-session')
      return AppUrl.USER_URL + 'admission-session/' + uniqueId;
    else if (status == 're-opened-session')
      return AppUrl.USER_URL + 're-opened-session/' + uniqueId;
    else return AppUrl.USER_URL + 'session-status/' + uniqueId;
  }

  static SUBJECT(uniqueId?: any): string {
    if (uniqueId) return AppUrl.USER_URL + 'subject/' + uniqueId;
    else return AppUrl.USER_URL + 'subject';
  }

  static SUBJECT_STATUS(uniqueId: any): string {
    return AppUrl.USER_URL + 'subject-status/' + uniqueId;
  }

  static STUDENT(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.USER_URL + 'student/' + uniqueId;
    } else {
      return AppUrl.USER_URL + 'student';
    }
  }

  static DASHBOARD(): string {
    return AppUrl.STUDENT_URL + 'dashboard';
  }

}
